<div class="activity">
  <div class="activity__title">
    <h2 translate>AKTIVITÄTEN</h2>
  </div>
  <div class="activity__content">
    <app-activity-item *ngFor="let activity of activities$ | async" [activity]="activity"></app-activity-item>
    <button
      class="activity__button activity__button--more"
      mat-flat-button
      color="accent"
      (click)="showAllActivities()"
      translate
    >
      Mehr anzeigen
    </button>
  </div>
</div>
